import { addError } from 'rdx/alert';
import * as API from 'service/ErplyAPI/company';

import { GET_COMPANY_INFO, EDIT_COMPANY_INFO } from './actionTypes';

/**
 * Fetch company info and save it in redux
 * Resolves when done fetching
 */
export const getCompanyInfo = () => async (dispatch) => {
  dispatch({ type: GET_COMPANY_INFO.START });
  try {
    const company = await API.getCompanyInfo();
    dispatch({ type: GET_COMPANY_INFO.SUCCESS, payload: company.records[0] });
  } catch (error) {
    dispatch(addError(error.message));
  }
};

export const editCompanyInfo = (params) => async (dispatch) => {
  dispatch({ type: EDIT_COMPANY_INFO.START });
  try {
    await API.editCompanyInfo({ ...params });
    dispatch({ type: EDIT_COMPANY_INFO.SUCCESS });
  } catch (error) {
    dispatch(addError(error.message));
  }
};
